import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { Router } from '@angular/router';
import { UserDto } from '@dto/userDto';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormService } from '@services/form/form.service';
import { StatusNotificationsService } from '@services/entity/statusNotifications.services'
import { UsersService } from '@services/entity/users.service';
import { NgxSpinnerService } from 'ngx-spinner';
import '@angular/localize/init';
import { plainToClass } from 'class-transformer';
import { Operator } from '../../models/operator';
import { OperatorsService } from '@services/entity/operators.service';
import { RfidCardsService } from '@services/entity/rfidCards.service'
import { CustomersService } from '@services/entity/customers.service';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { ChargingPointDto } from '../../dto/chargingPointDto';
import { ChargingStationDto } from '../../dto/chargingStationDto';
import { BlackboxService } from '../../services/entity/blackbox.service';
import { CustomersTableEntry } from '../../dto/customersTableEntry';
import { TransactionDto } from '../../dto/transactionDto';
import { TransactionSuccess } from '../../enums/transaction-success.enum';
import { Chart, ChartData, ChartOptions, ChartType, registerables } from "chart.js";
import { RfidCardDto } from '../../dto/rfidCardDto';


@Component({
  selector: 'app-operator',
  templateUrl: './operator.component.html',
  styleUrls: ['./operator.component.scss']
})
export class OperatorComponent implements OnInit {

  public user: UserDto;
  public customers: number;
  public chargingStations: any;
  public notifications: number;
  public blackboxes: number = 0;
  public models: number;
  public operator: Operator;
  public users: number;
  public offline: ChargingStationDto[];
  public searchCSResult: ChargingStationDto[];
  public searchCUResult: CustomersTableEntry[];
  public searchTRResult: TransactionDto[];
  public searchRFResult: RfidCardDto[];
  public hasTransaction: boolean = false;
  public hasLoaded: boolean = false;
  public searchTerm: string;
  public searchResult: boolean = false;
  hasError: boolean;
  public isOperator: boolean = false;
  public isCustomer: boolean = false;
  public isUser: boolean = false;
  public isSupporter: boolean = false;

  public total: number;


  constructor(
    private usersService: UsersService,
    public formService: FormService,
    private operatorsService: OperatorsService,
    private customersService: CustomersService,
    private rfidcardsService: RfidCardsService,
    private transactionsService: TransactionsService,
    private authenticationService: AuthenticationService,
    private chargingStationsService: ChargingStationsService,
    private blackBoxService: BlackboxService,
    private statusNotificationService: StatusNotificationsService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.usersService.getLoggedInUser().subscribe(result => {
      this.user = result;
    }, error => { });

    this.customersService.getCountofCustomers().subscribe(result => {
      this.customers = result;
    }, error => { });

    this.blackBoxService.getCount().subscribe(result => {
      this.blackboxes = result;
    }, error => { });

    this.chargingStationsService.getCountofChargingstations().subscribe(result => {
      this.chargingStations = result;
      this.chargingStations
      this.total = result.reduce((acc, current) => acc + current.count, 0);
    }, error => { });

    this.chargingStationsService.getCountOfModels().subscribe(result => {
      this.models = result;
    }, error => { });

    this.statusNotificationService.getCountOfStatusNotifications().subscribe(result => {
      this.notifications = result;
    }, error => { });

    this.usersService.getCountOfUsers().subscribe(result => {
      this.users = result;
    }, error => { });
    this.getRoles();
    this.createForm();
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) {
      this.isOperator = true;
    }
    if (this.authenticationService.userHasRole('Customer')) {
      this.isCustomer = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.isUser = true;
    }
    if (this.authenticationService.userHasRole('Supporter')) {
      this.isSupporter = true;
    }
  }


  createForm() {
    this.formService.validators = {
      searchTerm: [Validators.minLength(3)],
    }

    this.formService.form = new UntypedFormGroup({
      searchTerm: new UntypedFormControl(),
    });
  }

  searchForTerm() {
    this.hasError = false;
    this.searchTerm = this.formService.form.get('searchTerm').value;
    if (this.searchTerm.length >= 3) {
      this.chargingStationsService.search(this.searchTerm).subscribe(result => {
        this.searchResult = true;
        this.searchCSResult = result;
      }, error => { this.searchResult = false; })
      this.customersService.search(this.searchTerm).subscribe(result => {
        this.searchResult = true;
        this.searchCUResult = result;
      }, error => { this.searchResult = false; })
      this.transactionsService.search(this.searchTerm).subscribe(result => {
        this.searchResult = true;
        this.searchTRResult = result;
        this.searchTRResult.forEach(item => {
          item.successMessage = TransactionSuccess[item.success];
        })
      }, error => { this.searchResult = false; })
      this.rfidcardsService.search(this.searchTerm).subscribe(result => {
        this.searchResult = true;
        this.searchRFResult = result;
      }, error => { this.searchResult = false; })
      this.hasError = false;
    } else {
      this.searchResult = false;
      this.hasError = true;
    }
  }

  onSubmit(formValue) {
    this.searchForTerm();
  }
}
